import { Drawer, Tabs } from 'antd';
import classnames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import './style.scss';

const { TabPane } = Tabs;

const MainDrawer = (props) => {
  const onChangeTab = (key) => {
    props.onChangeTab(props.menu[+key]);
  };

  const renderTabPane = () => (
    _.map(props.menu, (x, i) => (
      <TabPane
        tab={(
          <div className="flex">
            {x.key === props.activeKey ? x.activeIcon : x.icon}
            {x.label}
            {x.subLabel && (
            <span className="main-drawer-sub-title">{x.subLabel}</span>
            )}
          </div>
          )}
        key={x.key}
      />
    ))
  );

  return (
    <Drawer
      className={classnames('main-drawer', props.className)}
      placement="left"
      closable={false}
      onClose={props.onClose}
      visible={props.visible}
      getContainer={false}
      style={{ position: 'absolute' }}
    >
      <Tabs
        activeKey={props.activeKey}
        tabPosition="left"
        onChange={onChangeTab}
      >
        {renderTabPane()}
      </Tabs>
    </Drawer>
  );
};

MainDrawer.defaultProps = {
  className: '',
  visible: false,
  activeKey: '0',
  menu: [],
  onClose: () => { },
  onChangeTab: () => { },
};
MainDrawer.propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
  activeKey: PropTypes.string,
  menu: PropTypes.arrayOf(PropTypes.shape()),
  onClose: PropTypes.func,
  onChangeTab: PropTypes.func,
};

export default MainDrawer;
